// extracted by mini-css-extract-plugin
export default {"pagination":"paginateCard_pagination__y0Yms","active":"paginateCard_active__PgmVx"};